import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass, renderList as _renderList, Fragment as _Fragment, vModelText as _vModelText, withDirectives as _withDirectives } from "vue"

const _hoisted_1 = { class: "bank-update-request-details-container" }
const _hoisted_2 = { class: "container-fluid" }
const _hoisted_3 = { class: "row" }
const _hoisted_4 = { class: "col-sm-12" }
const _hoisted_5 = {
  key: 0,
  class: "card"
}
const _hoisted_6 = {
  key: 1,
  class: "card"
}
const _hoisted_7 = { class: "card-body text-center py-5" }
const _hoisted_8 = { key: 2 }
const _hoisted_9 = { class: "card" }
const _hoisted_10 = { class: "card-header pb-0" }
const _hoisted_11 = { class: "d-flex justify-content-between align-items-center" }
const _hoisted_12 = { class: "d-flex gap-2" }
const _hoisted_13 = { class: "card-body" }
const _hoisted_14 = { class: "mb-4" }
const _hoisted_15 = { class: "row mb-4" }
const _hoisted_16 = { class: "col-md-6 mb-3" }
const _hoisted_17 = { class: "fw-bold" }
const _hoisted_18 = { class: "col-md-6 mb-3" }
const _hoisted_19 = { class: "fw-bold" }
const _hoisted_20 = { class: "col-md-6 mb-3" }
const _hoisted_21 = { class: "col-md-6 mb-3" }
const _hoisted_22 = { class: "col-md-6 mb-3" }
const _hoisted_23 = { class: "row mb-4" }
const _hoisted_24 = { class: "col-md-6 mb-3" }
const _hoisted_25 = { class: "col-md-6 mb-3" }
const _hoisted_26 = { class: "fw-bold" }
const _hoisted_27 = { class: "col-md-6 mb-3" }
const _hoisted_28 = {
  key: 0,
  class: "col-md-12 mb-3"
}
const _hoisted_29 = ["href"]
const _hoisted_30 = {
  key: 0,
  class: "row mb-4"
}
const _hoisted_31 = { class: "col-md-6 mb-3" }
const _hoisted_32 = { class: "col-md-6 mb-3" }
const _hoisted_33 = { class: "col-md-6 mb-3" }
const _hoisted_34 = { class: "row mb-4" }
const _hoisted_35 = { class: "col-md-6 mb-3" }
const _hoisted_36 = {
  key: 0,
  class: "text-muted"
}
const _hoisted_37 = { class: "col-md-6 mb-3" }
const _hoisted_38 = {
  key: 0,
  class: "col-md-12 mb-3"
}
const _hoisted_39 = {
  key: 1,
  class: "row mb-4"
}
const _hoisted_40 = { class: "col-md-12" }
const _hoisted_41 = { class: "border-bottom pb-2 mb-3" }
const _hoisted_42 = {
  key: 0,
  class: "col-md-6 mb-3"
}
const _hoisted_43 = {
  key: 1,
  class: "col-md-6 mb-3"
}
const _hoisted_44 = {
  key: 2,
  class: "col-md-6 mb-3"
}
const _hoisted_45 = {
  key: 3,
  class: "col-md-6 mb-3"
}
const _hoisted_46 = {
  key: 4,
  class: "col-md-12 mb-3"
}
const _hoisted_47 = { class: "alert alert-danger" }
const _hoisted_48 = {
  key: 2,
  class: "row mb-4"
}
const _hoisted_49 = { class: "col-md-12" }
const _hoisted_50 = { class: "table-responsive" }
const _hoisted_51 = { class: "table table-sm table-bordered" }
const _hoisted_52 = {
  key: 3,
  class: "row"
}
const _hoisted_53 = { class: "col-md-12" }
const _hoisted_54 = { class: "d-flex gap-2" }
const _hoisted_55 = {
  key: 0,
  class: "modal fade show",
  style: {"display":"block","background":"rgba(0,0,0,0.5)"},
  tabindex: "-1"
}
const _hoisted_56 = { class: "modal-dialog" }
const _hoisted_57 = { class: "modal-content" }
const _hoisted_58 = { class: "modal-header" }
const _hoisted_59 = { class: "modal-body" }
const _hoisted_60 = { class: "mb-3" }
const _hoisted_61 = { class: "form-label" }
const _hoisted_62 = { class: "mb-3" }
const _hoisted_63 = { class: "modal-footer" }
const _hoisted_64 = ["disabled"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          (_ctx.loading)
            ? (_openBlock(), _createElementBlock("div", _hoisted_5, [...(_cache[8] || (_cache[8] = [
                _createElementVNode("div", { class: "card-body text-center py-5" }, [
                  _createElementVNode("div", {
                    class: "spinner-border text-primary",
                    role: "status"
                  }, [
                    _createElementVNode("span", { class: "visually-hidden" }, "Loading...")
                  ]),
                  _createElementVNode("p", { class: "mt-2" }, "Loading request details...")
                ], -1)
              ]))]))
            : (_ctx.error)
              ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
                  _createElementVNode("div", _hoisted_7, [
                    _cache[10] || (_cache[10] = _createElementVNode("i", { class: "fa fa-exclamation-triangle fa-3x text-danger mb-3" }, null, -1)),
                    _createElementVNode("h5", null, _toDisplayString(_ctx.error), 1),
                    _createElementVNode("button", {
                      class: "btn btn-primary mt-3",
                      onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.goBack && _ctx.goBack(...args)))
                    }, [...(_cache[9] || (_cache[9] = [
                      _createElementVNode("i", { class: "fa fa-arrow-left" }, null, -1),
                      _createTextVNode(" Go Back ", -1)
                    ]))])
                  ])
                ]))
              : (_ctx.request)
                ? (_openBlock(), _createElementBlock("div", _hoisted_8, [
                    _createElementVNode("div", _hoisted_9, [
                      _createElementVNode("div", _hoisted_10, [
                        _createElementVNode("div", _hoisted_11, [
                          _cache[12] || (_cache[12] = _createElementVNode("h5", null, "Bank Update Request Details", -1)),
                          _createElementVNode("div", _hoisted_12, [
                            _createElementVNode("button", {
                              class: "btn btn-sm btn-secondary",
                              onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.goBack && _ctx.goBack(...args)))
                            }, [...(_cache[11] || (_cache[11] = [
                              _createElementVNode("i", { class: "fa fa-arrow-left" }, null, -1),
                              _createTextVNode(" Back ", -1)
                            ]))])
                          ])
                        ])
                      ]),
                      _createElementVNode("div", _hoisted_13, [
                        _createElementVNode("div", _hoisted_14, [
                          _createElementVNode("span", {
                            class: _normalizeClass(_ctx.getStatusBadge(_ctx.request.status).class),
                            style: {"font-size":"1.1em","padding":"0.5em 1em"}
                          }, _toDisplayString(_ctx.getStatusBadge(_ctx.request.status).label), 3)
                        ]),
                        _createElementVNode("div", _hoisted_15, [
                          _cache[18] || (_cache[18] = _createElementVNode("div", { class: "col-md-12" }, [
                            _createElementVNode("h6", { class: "border-bottom pb-2 mb-3" }, "Employee Information")
                          ], -1)),
                          _createElementVNode("div", _hoisted_16, [
                            _cache[13] || (_cache[13] = _createElementVNode("label", { class: "text-muted" }, "Employee Name", -1)),
                            _createElementVNode("p", _hoisted_17, _toDisplayString(_ctx.request.employeeId?.employeeName || 'N/A'), 1)
                          ]),
                          _createElementVNode("div", _hoisted_18, [
                            _cache[14] || (_cache[14] = _createElementVNode("label", { class: "text-muted" }, "Employee Code", -1)),
                            _createElementVNode("p", _hoisted_19, _toDisplayString(_ctx.request.employeeId?.employeeCode || 'N/A'), 1)
                          ]),
                          _createElementVNode("div", _hoisted_20, [
                            _cache[15] || (_cache[15] = _createElementVNode("label", { class: "text-muted" }, "Site Name", -1)),
                            _createElementVNode("p", null, _toDisplayString(_ctx.request.employeeId?.siteId?.siteName || 'N/A'), 1)
                          ]),
                          _createElementVNode("div", _hoisted_21, [
                            _cache[16] || (_cache[16] = _createElementVNode("label", { class: "text-muted" }, "Email", -1)),
                            _createElementVNode("p", null, _toDisplayString(_ctx.request.employeeId?.email || 'N/A'), 1)
                          ]),
                          _createElementVNode("div", _hoisted_22, [
                            _cache[17] || (_cache[17] = _createElementVNode("label", { class: "text-muted" }, "Phone", -1)),
                            _createElementVNode("p", null, _toDisplayString(_ctx.request.employeeId?.phone || 'N/A'), 1)
                          ])
                        ]),
                        _createElementVNode("div", _hoisted_23, [
                          _cache[24] || (_cache[24] = _createElementVNode("div", { class: "col-md-12" }, [
                            _createElementVNode("h6", { class: "border-bottom pb-2 mb-3" }, "New Bank Details (Requested)")
                          ], -1)),
                          _createElementVNode("div", _hoisted_24, [
                            _cache[19] || (_cache[19] = _createElementVNode("label", { class: "text-muted" }, "Account Number", -1)),
                            _createElementVNode("p", null, [
                              _createElementVNode("code", null, _toDisplayString(_ctx.request.accountNumber), 1)
                            ])
                          ]),
                          _createElementVNode("div", _hoisted_25, [
                            _cache[20] || (_cache[20] = _createElementVNode("label", { class: "text-muted" }, "Bank Name", -1)),
                            _createElementVNode("p", _hoisted_26, _toDisplayString(_ctx.request.bankName), 1)
                          ]),
                          _createElementVNode("div", _hoisted_27, [
                            _cache[21] || (_cache[21] = _createElementVNode("label", { class: "text-muted" }, "IFSC Code", -1)),
                            _createElementVNode("p", null, [
                              _createElementVNode("code", null, _toDisplayString(_ctx.request.ifscCode), 1)
                            ])
                          ]),
                          (_ctx.request.bankPassbookUrl)
                            ? (_openBlock(), _createElementBlock("div", _hoisted_28, [
                                _cache[23] || (_cache[23] = _createElementVNode("label", { class: "text-muted" }, "Bank Passbook Document", -1)),
                                _createElementVNode("div", null, [
                                  _createElementVNode("a", {
                                    href: _ctx.request.bankPassbookUrl,
                                    target: "_blank",
                                    class: "btn btn-sm btn-outline-primary"
                                  }, [...(_cache[22] || (_cache[22] = [
                                    _createElementVNode("i", { class: "fa fa-file-pdf-o" }, null, -1),
                                    _createTextVNode(" View Document ", -1)
                                  ]))], 8, _hoisted_29)
                                ])
                              ]))
                            : _createCommentVNode("", true)
                        ]),
                        (_ctx.request.employeeId?.bankDetails)
                          ? (_openBlock(), _createElementBlock("div", _hoisted_30, [
                              _cache[28] || (_cache[28] = _createElementVNode("div", { class: "col-md-12" }, [
                                _createElementVNode("h6", { class: "border-bottom pb-2 mb-3" }, "Current Bank Details")
                              ], -1)),
                              _createElementVNode("div", _hoisted_31, [
                                _cache[25] || (_cache[25] = _createElementVNode("label", { class: "text-muted" }, "Account Number", -1)),
                                _createElementVNode("p", null, [
                                  _createElementVNode("code", null, _toDisplayString(_ctx.request.employeeId.bankDetails.accountNumber || 'N/A'), 1)
                                ])
                              ]),
                              _createElementVNode("div", _hoisted_32, [
                                _cache[26] || (_cache[26] = _createElementVNode("label", { class: "text-muted" }, "Bank Name", -1)),
                                _createElementVNode("p", null, _toDisplayString(_ctx.request.employeeId.bankDetails.bankName || 'N/A'), 1)
                              ]),
                              _createElementVNode("div", _hoisted_33, [
                                _cache[27] || (_cache[27] = _createElementVNode("label", { class: "text-muted" }, "IFSC Code", -1)),
                                _createElementVNode("p", null, [
                                  _createElementVNode("code", null, _toDisplayString(_ctx.request.employeeId.bankDetails.ifscCode || 'N/A'), 1)
                                ])
                              ])
                            ]))
                          : _createCommentVNode("", true),
                        _createElementVNode("div", _hoisted_34, [
                          _cache[32] || (_cache[32] = _createElementVNode("div", { class: "col-md-12" }, [
                            _createElementVNode("h6", { class: "border-bottom pb-2 mb-3" }, "Request Information")
                          ], -1)),
                          _createElementVNode("div", _hoisted_35, [
                            _cache[29] || (_cache[29] = _createElementVNode("label", { class: "text-muted" }, "Requested By", -1)),
                            _createElementVNode("p", null, [
                              _createTextVNode(_toDisplayString(_ctx.request.requestedBy?.employeeName || 'N/A') + " ", 1),
                              (_ctx.request.requestedBy?.employeeCode)
                                ? (_openBlock(), _createElementBlock("span", _hoisted_36, "(" + _toDisplayString(_ctx.request.requestedBy.employeeCode) + ")", 1))
                                : _createCommentVNode("", true)
                            ])
                          ]),
                          _createElementVNode("div", _hoisted_37, [
                            _cache[30] || (_cache[30] = _createElementVNode("label", { class: "text-muted" }, "Requested Date", -1)),
                            _createElementVNode("p", null, _toDisplayString(_ctx.formatDate(_ctx.request.requestedAt)), 1)
                          ]),
                          (_ctx.request.remarks)
                            ? (_openBlock(), _createElementBlock("div", _hoisted_38, [
                                _cache[31] || (_cache[31] = _createElementVNode("label", { class: "text-muted" }, "Remarks", -1)),
                                _createElementVNode("p", null, _toDisplayString(_ctx.request.remarks), 1)
                              ]))
                            : _createCommentVNode("", true)
                        ]),
                        (_ctx.request.status === 'approved' || _ctx.request.status === 'rejected')
                          ? (_openBlock(), _createElementBlock("div", _hoisted_39, [
                              _createElementVNode("div", _hoisted_40, [
                                _createElementVNode("h6", _hoisted_41, _toDisplayString(_ctx.request.status === 'approved' ? 'Approval' : 'Rejection') + " Information ", 1)
                              ]),
                              (_ctx.request.approvedBy)
                                ? (_openBlock(), _createElementBlock("div", _hoisted_42, [
                                    _cache[33] || (_cache[33] = _createElementVNode("label", { class: "text-muted" }, "Approved By", -1)),
                                    _createElementVNode("p", null, _toDisplayString(_ctx.request.approvedBy?.employeeName || _ctx.request.approvedBy), 1)
                                  ]))
                                : _createCommentVNode("", true),
                              (_ctx.request.approvedAt)
                                ? (_openBlock(), _createElementBlock("div", _hoisted_43, [
                                    _cache[34] || (_cache[34] = _createElementVNode("label", { class: "text-muted" }, "Approved Date", -1)),
                                    _createElementVNode("p", null, _toDisplayString(_ctx.formatDate(_ctx.request.approvedAt)), 1)
                                  ]))
                                : _createCommentVNode("", true),
                              (_ctx.request.rejectedBy)
                                ? (_openBlock(), _createElementBlock("div", _hoisted_44, [
                                    _cache[35] || (_cache[35] = _createElementVNode("label", { class: "text-muted" }, "Rejected By", -1)),
                                    _createElementVNode("p", null, _toDisplayString(_ctx.request.rejectedBy?.employeeName || _ctx.request.rejectedBy), 1)
                                  ]))
                                : _createCommentVNode("", true),
                              (_ctx.request.rejectedAt)
                                ? (_openBlock(), _createElementBlock("div", _hoisted_45, [
                                    _cache[36] || (_cache[36] = _createElementVNode("label", { class: "text-muted" }, "Rejected Date", -1)),
                                    _createElementVNode("p", null, _toDisplayString(_ctx.formatDate(_ctx.request.rejectedAt)), 1)
                                  ]))
                                : _createCommentVNode("", true),
                              (_ctx.request.rejectionReason)
                                ? (_openBlock(), _createElementBlock("div", _hoisted_46, [
                                    _cache[37] || (_cache[37] = _createElementVNode("label", { class: "text-muted" }, "Rejection Reason", -1)),
                                    _createElementVNode("div", _hoisted_47, _toDisplayString(_ctx.request.rejectionReason), 1)
                                  ]))
                                : _createCommentVNode("", true)
                            ]))
                          : _createCommentVNode("", true),
                        (_ctx.request.oldBankDetails && _ctx.request.oldBankDetails.length > 0)
                          ? (_openBlock(), _createElementBlock("div", _hoisted_48, [
                              _cache[39] || (_cache[39] = _createElementVNode("div", { class: "col-md-12" }, [
                                _createElementVNode("h6", { class: "border-bottom pb-2 mb-3" }, "Bank Details History")
                              ], -1)),
                              _createElementVNode("div", _hoisted_49, [
                                _createElementVNode("div", _hoisted_50, [
                                  _createElementVNode("table", _hoisted_51, [
                                    _cache[38] || (_cache[38] = _createElementVNode("thead", null, [
                                      _createElementVNode("tr", null, [
                                        _createElementVNode("th", null, "Account Number"),
                                        _createElementVNode("th", null, "Bank Name"),
                                        _createElementVNode("th", null, "IFSC Code"),
                                        _createElementVNode("th", null, "Changed Date")
                                      ])
                                    ], -1)),
                                    _createElementVNode("tbody", null, [
                                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.request.oldBankDetails, (history, index) => {
                                        return (_openBlock(), _createElementBlock("tr", { key: index }, [
                                          _createElementVNode("td", null, [
                                            _createElementVNode("code", null, _toDisplayString(history.accountNumber), 1)
                                          ]),
                                          _createElementVNode("td", null, _toDisplayString(history.bankName), 1),
                                          _createElementVNode("td", null, [
                                            _createElementVNode("code", null, _toDisplayString(history.ifscCode), 1)
                                          ]),
                                          _createElementVNode("td", null, _toDisplayString(_ctx.formatDate(history.changedAt)), 1)
                                        ]))
                                      }), 128))
                                    ])
                                  ])
                                ])
                              ])
                            ]))
                          : _createCommentVNode("", true),
                        (_ctx.request.status === 'pending')
                          ? (_openBlock(), _createElementBlock("div", _hoisted_52, [
                              _createElementVNode("div", _hoisted_53, [
                                _createElementVNode("div", _hoisted_54, [
                                  _createElementVNode("button", {
                                    class: "btn btn-success",
                                    onClick: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.approveRequest && _ctx.approveRequest(...args)))
                                  }, [...(_cache[40] || (_cache[40] = [
                                    _createElementVNode("i", { class: "fa fa-check" }, null, -1),
                                    _createTextVNode(" Approve Request ", -1)
                                  ]))]),
                                  _createElementVNode("button", {
                                    class: "btn btn-danger",
                                    onClick: _cache[3] || (_cache[3] = 
//@ts-ignore
(...args) => (_ctx.showRejectModal && _ctx.showRejectModal(...args)))
                                  }, [...(_cache[41] || (_cache[41] = [
                                    _createElementVNode("i", { class: "fa fa-times" }, null, -1),
                                    _createTextVNode(" Reject Request ", -1)
                                  ]))])
                                ])
                              ])
                            ]))
                          : _createCommentVNode("", true)
                      ])
                    ])
                  ]))
                : _createCommentVNode("", true)
        ])
      ])
    ]),
    (_ctx.showRejectDialog)
      ? (_openBlock(), _createElementBlock("div", _hoisted_55, [
          _createElementVNode("div", _hoisted_56, [
            _createElementVNode("div", _hoisted_57, [
              _createElementVNode("div", _hoisted_58, [
                _cache[42] || (_cache[42] = _createElementVNode("h5", { class: "modal-title" }, "Reject Bank Update Request", -1)),
                _createElementVNode("button", {
                  type: "button",
                  class: "btn-close",
                  onClick: _cache[4] || (_cache[4] = 
//@ts-ignore
(...args) => (_ctx.closeRejectModal && _ctx.closeRejectModal(...args)))
                })
              ]),
              _createElementVNode("div", _hoisted_59, [
                _createElementVNode("div", _hoisted_60, [
                  _createElementVNode("label", _hoisted_61, [
                    _cache[43] || (_cache[43] = _createTextVNode("Employee: ", -1)),
                    _createElementVNode("strong", null, _toDisplayString(_ctx.request?.employeeId?.employeeName), 1)
                  ])
                ]),
                _createElementVNode("div", _hoisted_62, [
                  _cache[44] || (_cache[44] = _createElementVNode("label", { class: "form-label" }, [
                    _createTextVNode("Rejection Reason "),
                    _createElementVNode("span", { class: "text-danger" }, "*")
                  ], -1)),
                  _withDirectives(_createElementVNode("textarea", {
                    "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.rejectionReason) = $event)),
                    class: "form-control",
                    rows: "4",
                    placeholder: "Enter the reason for rejection...",
                    required: ""
                  }, null, 512), [
                    [_vModelText, _ctx.rejectionReason]
                  ]),
                  _cache[45] || (_cache[45] = _createElementVNode("small", { class: "text-muted" }, "Please provide a clear reason for the employee", -1))
                ])
              ]),
              _createElementVNode("div", _hoisted_63, [
                _createElementVNode("button", {
                  type: "button",
                  class: "btn btn-secondary",
                  onClick: _cache[6] || (_cache[6] = 
//@ts-ignore
(...args) => (_ctx.closeRejectModal && _ctx.closeRejectModal(...args)))
                }, "Cancel"),
                _createElementVNode("button", {
                  type: "button",
                  class: "btn btn-danger",
                  onClick: _cache[7] || (_cache[7] = 
//@ts-ignore
(...args) => (_ctx.confirmReject && _ctx.confirmReject(...args))),
                  disabled: !_ctx.rejectionReason || _ctx.rejectionReason.trim() === ''
                }, [...(_cache[46] || (_cache[46] = [
                  _createElementVNode("i", { class: "fa fa-times" }, null, -1),
                  _createTextVNode(" Reject Request ", -1)
                ]))], 8, _hoisted_64)
              ])
            ])
          ])
        ]))
      : _createCommentVNode("", true)
  ]))
}